"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createLikeCallbackCreator = void 0;
const auth_1 = require("../api/auth");
const tracks_1 = require("../api/tracks");
const ModelStatus_1 = require("../types/ModelStatus");
const ScreenState_1 = require("../types/ScreenState");
const TracksType_1 = require("../types/TracksType");
const isTrackLiked_1 = require("../utils/tracks/isTrackLiked");
function createLikeCallbackCreator(playerModel, tracksModel) {
    return (trackData) => {
        let loading = false;
        return async () => {
            if (loading) {
                return;
            }
            else {
                loading = true;
            }
            if (!(0, isTrackLiked_1.isTrackLiked)(trackData)) {
                await (0, tracks_1.postLike)(trackData.id);
                if (!auth_1.username) {
                    throw new Error('username is undefined');
                }
                trackData.likes.push({ username: auth_1.username });
            }
            else {
                await (0, tracks_1.postDislike)(trackData.id);
                trackData.likes = trackData.likes.filter((like) => like.username !== auth_1.username);
            }
            playerModel.onTrackInfoChange(trackData);
            if (playerModel.tracksType === TracksType_1.TracksType.Favorite) {
                if ((0, isTrackLiked_1.isTrackLiked)(trackData)) {
                    playerModel.originalTracks.push(trackData);
                }
                else {
                    playerModel.originalTracks = playerModel.originalTracks.filter((track) => track.id !== trackData.id);
                }
                playerModel.onTrackListChange();
            }
            if (tracksModel.tracksType === TracksType_1.TracksType.Favorite) {
                tracksModel.status = ModelStatus_1.ModelStatus.Pending;
                tracksModel.onUpdate(ScreenState_1.ScreenState.Tracks);
                tracksModel.setAll(await (0, tracks_1.loadFavorites)());
                tracksModel.status = ModelStatus_1.ModelStatus.Success;
                tracksModel.onUpdate(ScreenState_1.ScreenState.Tracks);
            }
            loading = false;
        };
    };
}
exports.createLikeCallbackCreator = createLikeCallbackCreator;
